@if (showContent) {
  <ng-content></ng-content>
}
<router-outlet></router-outlet>
<router-outlet name="logout"></router-outlet>
@if (showLogoutDialog$ | async) {
  <db-sign-out-confirmation></db-sign-out-confirmation>
}
